/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global window localStorage console document, Office */


import { Client } from "@microsoft/microsoft-graph-client";

import { PublicClientApplication, InteractionType } from "@azure/msal-browser";

 import { AuthCodeMSALBrowserAuthenticationProvider } from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";


// Office.onReady((info) => {
//   if (info.host === Office.HostType.Outlook) {
//   }
// });
// Office.onReady()
//     .then(function() {
//         Office.context.ui.addHandlerAsync(
//             Office.EventType.DialogParentMessageReceived,
//             onMessageFromParent);
//     });
Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
      
   document.getElementById("getProfileButton").onclick = run;
}
});

// function onMessageFromParent(arg) {
//        console.log(arg);
      
//       const messageFromParent = JSON.parse(arg.message);
//        console.log(messageFromParent);

//   var text = messageFromParent.name;
//        console.log(text);
  
//   }
export async function run() {
  //let param = arg.message;
      // console.log(param);

  const config = {
    auth: {
      clientId: 'bf0048cc-3a0a-4f85-86ea-4ab96cead409',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: 'https://add-ons.wrender.co.uk/taskpane.html',
    }
  };
  console.log(config);

  var client = new PublicClientApplication(config);
  const options = {
    authProvider: new AuthCodeMSALBrowserAuthenticationProvider(client, {
      account: {}, // the AccountInfo instance to acquire the token for.
      interactionType:InteractionType.Popup , // msal-browser InteractionType
      scopes: ["user.read","api://add-ons.wrender.co.uk/bf0048cc-3a0a-4f85-86ea-4ab96cead409/access_as_user"] // example of the scopes to be passed
    }
    )
  }; 
  console.log(options);

  var graphClient = Client.initWithMiddleware(options);
  console.log(graphClient);
  let profile = await graphClient.api('/me').get();
  console.log(profile);

  let data = [];
  let userProfileInfo = [];
  userProfileInfo.push(profile["id"]);
  userProfileInfo.push(profile["mail"]);
 
    
  for (let i = 0; i < userProfileInfo.length; i++) {
    if (userProfileInfo[i] !== null) {
      data.push(userProfileInfo[i]);
    }
  }
  //let emailbody = localStorage.getItem("emailBody");
  const queryString = window.location.search;
  console.log(queryString);
  const urlParams = new URLSearchParams(queryString);
  console.log(urlParams);

 


 
  let emailbody = urlParams.get('emailbody')
  console.log(emailbody);
  let et = urlParams.get('et')
  console.log(et);
        let encodedstring = encodeURIComponent(emailbody);
        let limitedstring = encodedstring.substring(0,2000);
     var source = "https://add-ons.siengage.com/redwheel-plato/show-options?e=" + data[1] + "&id=" + data[0] + "&body=" + limitedstring;
 console.log(source);
      
      //   var source="https://add-ons.wrender.co.uk/taskpane.html"
        //  document.getElementById("textareaId").textContent = source1;
//  document.getElementById("textareaId1").textContent = encodedstring;
document.getElementById('myIframe').src=source;
//Office.context.ui.displayDialogAsync(source, {height: 50, width: 50, displayInIframe: true});
        
//   var body = Office.context.mailbox.item.body;
//   console.log(body);
//   // Get the body asynchronous as text
//   body.getAsync(Office.CoercionType.Text, function (asyncResult) {
//     if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {
//       // do something with the error
//     } else {
//         let emailbody = asyncResult.value;
//         let encodedstring = encodeURIComponent(emailbody);
//         let limitedstring = encodedstring.substring(0,2000);
//      var source = "https://add-ons.siengage.com/redwheel-plato/show-options?e=" + data[1] + "&id=" + data[0] + "&body=" + limitedstring;
//  console.log(source);
      
//       //   var source="https://add-ons.wrender.co.uk/taskpane.html"
//         //  document.getElementById("textareaId").textContent = source1;
// //  document.getElementById("textareaId1").textContent = encodedstring;
// document.getElementById('myIframe').src=source;
// //Office.context.ui.displayDialogAsync(source, {height: 50, width: 50, displayInIframe: true});
        
//     }
//   });
}

// function writeDataToOfficeDocument(result) {
//   let data = [];
//   let userProfileInfo = filterUserProfileInfo(result);

//   for (let i = 0; i < userProfileInfo.length; i++) {
//     if (userProfileInfo[i] !== null) {
//       data.push(userProfileInfo[i]);
//     }
//   }

//   let userInfo = "";
//   for (let i = 0; i < data.length; i++) {
//     userInfo += data[i] + "\n";
//   }

//   Office.context.mailbox.item.body.setSelectedDataAsync(userInfo, { coercionType: Office.CoercionType.Html });
// }
